import React from 'react';
import { splitByCommas } from '../../helpers/functions';

const TransactionsBalance = ({ balance, overdue }) => (
    <div className="transactions_balance" aria-label="Баланс / Просроченная задолженность">
        {balance != null && (
            <strong className={Number(balance) > 0 ? 'green_text' : Number(balance) < 0 ? 'red_text' : ''}>
                {splitByCommas(balance)} ₽
            </strong>
        )}
        {balance != null && overdue != null && ' / '}
        {overdue != null && (
            <strong className="red_text">{splitByCommas(overdue)} ₽</strong>
        )}
    </div>
);

export default TransactionsBalance;
